import StudentAttendancePage from './StudentAttendancePage';
const AdminStudentAttendance = () => <StudentAttendancePage isAdmin={true} />;
export default AdminStudentAttendance;